/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateUserMutationVariables = Types.Exact<{
  user: Types.UserInput;
}>;

export type UpdateUserMutation = { __typename?: 'Mutation'; updateUser: { __typename?: 'User'; _id: string } };

export type UpdateUserPreferenceMutationVariables = Types.Exact<{
  preference: Array<Types.PreferenceInput> | Types.PreferenceInput;
}>;

export type UpdateUserPreferenceMutation = { __typename?: 'Mutation'; updateUserPreference: boolean };

export type UpdateUserMotivatedMutationVariables = Types.Exact<{
  questions: Array<Types.QuestionAnswerInput> | Types.QuestionAnswerInput;
}>;

export type UpdateUserMotivatedMutation = { __typename?: 'Mutation'; updateUserMotivated: Array<{ __typename?: 'QuestionAnswerDate'; questionId: string }> };

export type GetUsersQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetUsersQuery = {
  __typename?: 'Query';
  getUsers: Array<{ __typename?: 'User'; _id: string; email: string; preferences: Array<{ __typename?: 'Preference'; time: string; importance: string; domainId: string }> }>;
};

export const UpdateUserDocument = gql`
  mutation updateUser($user: UserInput!) {
    updateUser(input: $user) {
      _id
    }
  }
`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserPreferenceDocument = gql`
  mutation updateUserPreference($preference: [PreferenceInput!]!) {
    updateUserPreference(input: $preference)
  }
`;
export type UpdateUserPreferenceMutationFn = Apollo.MutationFunction<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;

/**
 * __useUpdateUserPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferenceMutation, { data, loading, error }] = useUpdateUserPreferenceMutation({
 *   variables: {
 *      preference: // value for 'preference'
 *   },
 * });
 */
export function useUpdateUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>(UpdateUserPreferenceDocument, options);
}
export type UpdateUserPreferenceMutationHookResult = ReturnType<typeof useUpdateUserPreferenceMutation>;
export type UpdateUserPreferenceMutationResult = Apollo.MutationResult<UpdateUserPreferenceMutation>;
export type UpdateUserPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;
export const UpdateUserMotivatedDocument = gql`
  mutation updateUserMotivated($questions: [QuestionAnswerInput!]!) {
    updateUserMotivated(input: $questions) {
      questionId
    }
  }
`;
export type UpdateUserMotivatedMutationFn = Apollo.MutationFunction<UpdateUserMotivatedMutation, UpdateUserMotivatedMutationVariables>;

/**
 * __useUpdateUserMotivatedMutation__
 *
 * To run a mutation, you first call `useUpdateUserMotivatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMotivatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMotivatedMutation, { data, loading, error }] = useUpdateUserMotivatedMutation({
 *   variables: {
 *      questions: // value for 'questions'
 *   },
 * });
 */
export function useUpdateUserMotivatedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMotivatedMutation, UpdateUserMotivatedMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserMotivatedMutation, UpdateUserMotivatedMutationVariables>(UpdateUserMotivatedDocument, options);
}
export type UpdateUserMotivatedMutationHookResult = ReturnType<typeof useUpdateUserMotivatedMutation>;
export type UpdateUserMotivatedMutationResult = Apollo.MutationResult<UpdateUserMotivatedMutation>;
export type UpdateUserMotivatedMutationOptions = Apollo.BaseMutationOptions<UpdateUserMotivatedMutation, UpdateUserMotivatedMutationVariables>;
export const GetUsersDocument = gql`
  query getUsers {
    getUsers {
      _id
      email
      preferences {
        time
        importance
        domainId
      }
    }
  }
`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
}
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
